import { render } from "./ProformaDetalle.vue?vue&type=template&id=275c6ad7&scoped=true"
import script from "./ProformaDetalle.vue?vue&type=script&lang=js"
export * from "./ProformaDetalle.vue?vue&type=script&lang=js"

import "./ProformaDetalle.vue?vue&type=style&index=0&id=275c6ad7&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275c6ad7"]])

export default __exports__